import { IPopupsService, AddToCollection } from '@src/types/Popups';
import { ServiceReference, ServiceName } from '@src/types/Services';
import {
  setPopup,
  openCollectOverlay,
  openSetCreatorCountriesOverlay,
  setPopupLoading,
} from '@src/state/popupAtoms';
import { EPopup, PopupsState } from '@src/types/common';
import { GlobalError } from '@src/types/GlobalError';
import { Pathname } from '@src/types/Browsing';
import { BrowsingService } from './Browsing';
import { MediaView } from 'common';

export class PopupsService implements IPopupsService {
  private browsingService?: BrowsingService;

  private globalErrorService?: GlobalError;

  constructor(servicesPromise: ServiceReference) {
    servicesPromise.then((services) => {
      this.browsingService = services.get<BrowsingService>(ServiceName.Browsing);
      this.globalErrorService = services.get<GlobalError>(ServiceName.GlobalError);
    });
  }

  /**
     * Open a popup and load given data in it
     */
  public open<T extends EPopup>(popup: T, data: PopupsState[T]): void {
    setPopup(popup, data);
  }

  /**
     * Close a popup
     */
  public close(popup: EPopup) {
    this.browsingService?.goToPage(this.getBasePath());
    setPopup(popup, null);
  }

  /**
     * Open the collect Panel
     */
  public openCollectOverlay(step: 'add' | 'new', media?: AddToCollection, isAutoCollection?: boolean): void {
    openCollectOverlay(step, media, isAutoCollection);
  }

  public openSetCreatorCountriesOverlay(mediaList: MediaView[]): void {
    openSetCreatorCountriesOverlay(mediaList);
  }

  public async setPopupLoading(loading: boolean): Promise<void> {
    setPopupLoading(loading);
  }

  private getBasePath(): Pathname {
    let path = window.location.pathname;
    if (/\/discover\/[^?]+/.test(path)) {
      path = Pathname.discover;
    }
    const testOpenedCollection = /(\/collections\/[^/]+)\/[^/]/.exec(path);
    if (testOpenedCollection && testOpenedCollection.length > 1) {
      path = testOpenedCollection[1];
    }
    return path as Pathname;
  }
}
